import {
    TextField,
    Typography,
    Grid,
    CircularProgress
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { ReactElement} from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { globalStyles } from "../../../assets/globalStyles";
import { selectGrenzwertsatzListe, selectLoadingGrenzwertsatzListe, setAktuellerGrenzwertsatzTemp, selectAktuellerGrenzwertsatzTemp, setIsChangedGrenzwert } from "./pqIndexSlice";

export default function GrenzwertFilter(): ReactElement {
    
    const dispatch = useAppDispatch();
    const classes = {

        ...globalStyles(),
    };

    const grenzwertsatzLoading = useAppSelector(selectLoadingGrenzwertsatzListe);
    const grenzwertsatz= useAppSelector(selectGrenzwertsatzListe);
    const aktuellerGrenzwertsatz = useAppSelector(selectAktuellerGrenzwertsatzTemp);

    return (
        <div>
            <Grid item md={12} style={{ marginBottom: "20px" }} />
            <Grid item md={12} style={{ textAlign: 'left' }}>
                <Typography  color="primary">
                    Grenzwertsatzauswahl
                </Typography>
                <Autocomplete
                    id="select-grenzwert"
                    noOptionsText={<React.Fragment>
                        {grenzwertsatzLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Grenzwertsätze"}</React.Fragment>}
                    value={aktuellerGrenzwertsatz}
                    options={grenzwertsatz}
                    getOptionLabel={(option) => option}
                    onChange={(event,nV) => {
                        dispatch(setAktuellerGrenzwertsatzTemp(nV != null ? nV : ""));
                        dispatch(setIsChangedGrenzwert(true));
                    }}
                    renderInput={(params) => 
                        <TextField 
                            {...params} 
                            label="Grenzwertsatz" 
                            variant="outlined" 
                            InputLabelProps={{ ...params.InputLabelProps }}
                            InputProps={{ ...params.InputProps}}
                        />}
                    className={classes.selectEmpty}
                    />
            </Grid>
        </div>
    );
}
